export default "__VITE_ASSET__8ak8FTbE__"